/**
 * Trạng thái hóa đơn bên inbot
 */
export default {
  Root: 1,
  Replace: 2,
  Adjustment: 3,
  Replaced: 4,
  Adjustmented: 5,
  Deleted: 6,
  Unknown: 7,
};
